import React, { useEffect, useState } from "react";
import PieChart from "../charts/PieChart";
import { useGetVisitorsCountByNationality } from "../../hooks/dashboard/query";
import { PieChartData } from "../../constants/common";
import { useTranslation } from "react-i18next";
import Loader from "../loader";

const VisitorsByNationalityCard = () => {
  const { i18n, t } = useTranslation();

  const [visitorsCountByNationality, setVisitorsCountByNationality] = useState<
    PieChartData[]
  >([]);

  const {
    data: allVisitorsCountByNationality,
    isPending: isAllVisitorsCountByNationalityLoading,
  } = useGetVisitorsCountByNationality();

  useEffect(() => {
    if (allVisitorsCountByNationality) {
      const mappedVisitorsCount = allVisitorsCountByNationality.map((item) => ({
        name:
          i18n.language === "en"
            ? item.nationalityName_En
            : item.nationalityName_Ar,
        value: item.nationalityCount,
      }));

      setVisitorsCountByNationality(mappedVisitorsCount);
    }
  }, [
    setVisitorsCountByNationality,
    i18n.language,
    allVisitorsCountByNationality,
  ]);

  return (
    <div className="bg-white rounded-[15px] px-5 py-4 xl:p-5 flex flex-col gap-7 w-full">
      <div className="flex justify-between items-center gap-2">
        <h1 className="text-xl">{t("visitorsByNationality")}</h1>
      </div>

      {isAllVisitorsCountByNationalityLoading ? (
        <div className="h-[350px] flex justify-center">
          <Loader />
        </div>
      ) : visitorsCountByNationality.length > 0 ? (
        <PieChart data={visitorsCountByNationality} innerRadius={30} />
      ) : (
        <div className="h-[350px]">
          <p className="text-xs">{t("noVisitors")}</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(VisitorsByNationalityCard);
